module.exports = __webpack_public_path__ + "static/media/ke.1bfd3168.webp";